@if (routerEvent$ | async) {}
@if (navigationItem$ | async) {}
@if (activeChild && currentPath()) {
  <div
    class="flex align-items-center justify-content-center top-header-tab relative active-tab"
    #headerTab
  >
    <div class="active-left"></div>
    <div class="inner-tab-container">
      <a
        class="inner-tab flex align-items-center gap-1"
        (click)="op.toggle($event)"
      >
        <span class="webkit-box-one-line body-medium-medium">{{
          (navigationItem() | zGetActiveChild: activeChild : currentPath()).name
        }}</span>
        <em class="ml-auto ph ph-caret-down"></em>
      </a>
      <p-overlayPanel #op>
        <div class="overlay-body">
          @if (navigationItem().children.length) {
            @for (item of navigationItem().children; track $index) {
              <z-menu-collapse-item
                [menuItemData]="item"
                [active]="activeChild && activeChild.id === item.id"
              />
            }
          }
        </div>
      </p-overlayPanel>
    </div>
    <div class="active-right"></div>
  </div>
}
